import { v4 as uuidv4 } from 'uuid';
// import { getName } from '../utils/stringUtils.js'
// import { addLineBreak, convertImage2LogoHtmlText, convertText2Html, surroundWithHtmlTag, convertFormData2HtmlTable} from './formatEmail.js'
// import { sendEmail, sendEmailWithAttachment } from './email.js'
// import { sendWordPressEmail, sendPreparedEmail } from './wordpress-email.js'
// import { config } from '../utils/config.js'

const getFormData = (formId) => {
    let elements = document.getElementById(formId).elements
    let requestFormData = {}
    for(let i = 0 ; i < elements.length ; i++) {
        let item = elements.item(i)
        requestFormData[item.name] = item.value
    }
    requestFormData.id = uuidv4()     // requestFormData.id = Math.random().toString(36).substr(2,11)
    requestFormData.timeStamp = new Date()
    const formData = {...requestFormData}
    document.getElementById(formId).reset()
    return formData
}

// const companyTitle = config.title
// const CONTACT_US_ID = 'contact-us'
// const REQUEST_QUOTE_ID = 'request-form'

// const getLogoFileName = () => {
//     let port = window.location.port ? `:${window.location.port}` : ''
//     let imageUrl = `${window.location.protocol}//${window.location.hostname}${port}/assets/images/logo/fantasticGreen.png`
//     let imageObj = {image: imageUrl, altText: "FantasticLogo"}
//     return imageObj
// }

// const prepareAndSendEmail = (emailObject) => {
//     if (config.sendAttachments.toLowerCase() === 'true') {
//         emailObject.attachments =  [{name: 'fantastic-icon.png', path: '/assets/images/logo/fantasticGreen.png'}]
//         sendEmailWithAttachment(emailObject)
//     } else {
//         sendEmail(emailObject)
//     }
// }

// // WordPress native email sending (unlimited, no external dependencies)
// const sendWordPressNativeEmail = async (formData) => {
//     try {
//         // console.log('Using WordPress native email system (unlimited emails)');
//         const result = await sendWordPressEmail(formData);
//         // console.log('WordPress native email sent successfully:', result);
//         return result;
//     } catch (error) {
//         console.error('WordPress native email failed:', error);
//         throw error;
//     }
// }

// const sendEmailToCustomer = async (formData, formId) => {
//     if (formId !== CONTACT_US_ID &&  formId !== REQUEST_QUOTE_ID) {
//         return
//     }

//     try {
//         await sendPreparedEmail(formData, 'customer');
//     } catch (error) {
//         console.error('WordPress native email failed:', error);
//     }
// }

// const sendEmailToTeam = async (formData, formId) => {
//     if (formId !== CONTACT_US_ID &&  formId !== REQUEST_QUOTE_ID) {
//         return
//     }
//         try {
//             await sendPreparedEmail(formData, 'team');
//         } catch (error) {
//             console.error('WordPress native team email failed:', error);
//         }
// }

// const sendWhatsappToTeam = (requestFormData, formId) => {
//     if (formId !== CONTACT_US_ID &&  formId !== REQUEST_QUOTE_ID) {
//         return
//     }
//     // let subject = ''
//     let salutation = `Hello Team,`

//     let signOff = `Thanks and regards`

//     // let imgObj = getLogoFileName()
//     // let messageBody = convertImage2LogoHtmlText( imgObj )
//     // messageBody += addLineBreak('hr')
//     // messageBody += addLineBreak('br')
//     // messageBody += addLineBreak('br')
//     // messageBody += convertText2Html(salutation)
//     // messageBody += addLineBreak('br')
//     let messageBody = ``
//     messageBody += salutation
//     messageBody += `\n`
//     if (formId === CONTACT_US_ID) {
//         // subject = `[${companyTitle} #${requestFormData.id}] Customer ${requestFormData.fullName.toUpperCase()} has a query!`
//         messageBody += `Customer, *${requestFormData.fullName}*, with email id *${requestFormData.email}* and mobile *${requestFormData.phone}* contacted with a query.\n`
//         messageBody += `Message: ${requestFormData.message}.`
//     } else {
//         // subject = `[${companyTitle} #${requestFormData.id}] Customer ${requestFormData.firstName.toUpperCase()} requests a quote`
//         // messageBody += convertFormData2HtmlTable(requestFormData)
//         messageBody += JSON.stringify(requestFormData)
//     }
//     // messageBody += addLineBreak('br')
//     messageBody += `\n`
//     messageBody += signOff
//     messageBody += `\n`
//     // let sendEmailObject = getEmailObject(process.env.customerEmail, subject, messageBody)
//     // prepareAndSendEmail(sendEmailObject)
//     publishOnWhatsapp(messageBody)
// }

export { /*prepareAndSendEmail, sendEmailToCustomer, sendEmailToTeam, */getFormData }
